import axiosBasicInstance from '../axiosConfig';

// const getRosterItems = async ({ rosterId, fromDate, endDate, shiftId }) => {
//    try {
//       const response = await axiosBasicInstance.get('/management/roster/item', { params: { rosterId, fromDate, endDate, shiftId } });

//       return response;
//    } catch (error) {
//       throw error;
//    }
// };

const getRosterItems = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/roster/item/list', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const addRosterItem = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/addRosterItem', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteRosterItem = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/deleteRosterItem', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const editRosterItem = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/editRosterItem', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const addUserRoster = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/addUserRoster', data);
      return response;
   } catch (error) {
      throw error;
   }
};

export { addRosterItem, getRosterItems, deleteRosterItem, editRosterItem, addUserRoster};
